import { Typography, TypographyProps } from '@mui/material';
import { combineSX } from '@/utils/combineSX';
import { DpTextH4DisSX, DpTextH4SX } from '@/components/blocks/DpLibrary/DpH4/style';

export const DpH4 = ({ children, component, sx, ...props }: TypographyProps) => (
	<Typography
		component={component || 'h4'}
		sx={combineSX([DpTextH4SX, ...(Array.isArray(sx) ? sx : [sx])])}
		{...props}
	>
		{children}
	</Typography>
);

export const DpH4Dis = ({ children, component, sx, ...props }: TypographyProps) => (
	<Typography
		component={component || 'h4'}
		sx={combineSX([DpTextH4DisSX, ...(Array.isArray(sx) ? sx : [sx])])}
		{...props}
	>
		{children}
	</Typography>
);
